//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { searchTransactionBar } from '../components'
export default {
  name: 'PtTransPage',
  extends: vComponent,
  components: { searchTransactionBar },
  data () {
    return {
      items: [], // 會員點數紀錄
      columns: [ // 欄位宣告
        { name: 'CREATEDATE',
          label: '交易日期',
          field: 'CREATEDATE',
          format: (val, row) => moment(val).format('YYYY/MM/DD')
        },
        { name: 'STORE_NAME',
          label: '門市',
          field: 'STORE_NAME'
        },
        { name: 'RECORD',
          label: '活動名稱',
          field: 'RECORD'
        },
        { name: 'ADD_POINT',
          label: '交易點數',
          field: 'ADD_POINT'
        },
        { name: 'CRT_POINT',
          label: '累計點數',
          field: 'CRT_POINT'
        }
      ],
      visibleColumns: ['CREATEDATE', 'STORE_NAME', 'RECORD', 'ADD_POINT', 'CRT_POINT'],
      pagination: {
        page: 1, // 目前第幾頁
        rowsPerPage: 50, // 每頁幾筆
        rowsNumber: 20 // 總筆數
      },
      meta: {},
      searchBarId: 'pt_trans_search',
      queryOpt: null // 查詢參數
    }
  },
  computed: {
    ...mapGetters([
      'builderHost',
      'dateFormat',
      'site',
      'storeList'
    ])
  },
  async created () {
    if (this.$q.screen.lt.sm) {
      this.visibleColumns = ['CREATEDATE', 'RECORD', 'ADD_POINT', 'CRT_POINT']
    }
    await this.doQuery()
  },
  mounted () {
    this.addHandler()
    console.log(`storeKeyMap==`)
    console.log(this.storeKeyMap)
  },
  methods: {
    addHandler () {
      this.on('PtTrans.Query', async () => {
        await this.doQuery()
      })
      this.on('SearchTransactionBar.Search', async (searchBarId, searchObj) => {
        if (searchBarId === this.searchBarId) {
          console.log(`searc obj searchBarId =${searchBarId}`)
          console.log(searchObj)
          let queryOpt = {}
          if (searchObj.STOCK_NO !== '') queryOpt.STOCK_NO = searchObj.STOCK_NO
          // 因為db存的是utc時間 所以查詢需要-8去查才會取得預期的結果
          const sDate = searchObj.sDate !== null && searchObj.sDate !== '' ? moment(searchObj.sDate).subtract(8, 'hour').format() : null
          const eDate = searchObj.eDate !== null && searchObj.eDate !== '' ? moment(searchObj.eDate).add(8, 'hour').format() : null
          console.log(`sDate=${sDate} eDate=${eDate}`)
          if (sDate !== null && eDate !== null) {
            // 區間
            console.log('between!!')
            queryOpt.CREATEDATE = [sDate, eDate] // 以array送出
          } else if (sDate !== null) {
            // 只有開始
            queryOpt.CREATEDATE = `>=${sDate}`
          } else if (searchObj.eDate !== null) {
            // 只有結束
            queryOpt.CREATEDATE = `<=${eDate}`
          }
          this.queryOpt = queryOpt
          await this.doQuery()
        }
      })
    },
    async doQuery () {
      const data = { SITE: this.site, ID_NO: this.params.id_no }
      data.countPerPage = this.pagination.rowsPerPage
      data.currentPage = this.pagination.page
      // 加入排序
      data.order = `CREATEDATE,DESC`
      // 加入查詢參數
      if (this.queryOpt !== null) {
        for (const prop in this.queryOpt) {
          if (this.queryOpt[prop] !== null) data[prop] = this.queryOpt[prop]
        }
      }
      const response = await this.fetch('builderApi', this.builderHost, 'crm_pt_trans', data)
      this.items = response.data !== null ? response.data : []
      this.meta = response.meta
      this.pagination.rowsNumber = this.meta.total
    },
    async clickDetailBtn (props) {
    },
    async onRequest (props) {
      const { page, rowsPerPage } = props.pagination
      // const filter = props.filter
      this.pagination.page = page
      this.pagination.rowsPerPage = rowsPerPage
      console.log('on request props=')
      console.log(props)
      await this.doQuery()
    }
  }
}
